////// HERO KOA-O //////
var koaOPostcodeRegex = /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}$/;

var koaOMessages = {
    not_found: "We couldn't find that postcode. Check it and try again.",
    busy: "Lots of checks going on right now. Give it a minute and try again.",
    error: "The address check did not come back. Try again in a moment.",
    load: "The deals did not load. Refresh the page and try again."
};

// Helper to show spinner in button
function koaOShowButtonSpinner($btn) {
    if (!$btn.data("original-html")) {
        $btn.data("original-html", $btn.html());
    }
    // Hold the width so the button doesn't shrink around the spinner
    $btn.css("min-width", $btn.outerWidth()).addClass("is-loading").prop("disabled", true).html('<span class="koa-o-spinner"></span>');
}

// Helper to hide spinner and restore button content
function koaOHideButtonSpinner($btn) {
    $btn.removeClass("is-loading").css("min-width", "").html($btn.data("original-html") || "").prop("disabled", false);
}

// The compare button needs both an address and a provider
function koaOUpdateCompare($hero) {
    var ready = $hero.find(".koa-o-address").val() && $hero.find(".koa-o-provider").val();
    $hero.find(".koa-o-compare").prop("disabled", !ready);
}

function koaOFillAddresses($hero, addresses) {
    var $select = $hero.find(".koa-o-address");
    $select.find("option:not(:first)").remove();
    jQuery.each(addresses, function(i, address) {
        jQuery("<option>").val(address.uprn).text(address.label).attr("data-postcode", address.postcode).appendTo($select);
    });
    if (addresses.length === 1) {
        $select.val(addresses[0].uprn);
    }
    koaOUpdateCompare($hero);
}

// Asked once, after the first postcode: the list is the same for everyone
function koaOLoadProviders($hero) {
    if ($hero.data("koaOProvidersAsked")) {
        return;
    }
    $hero.data("koaOProvidersAsked", true);
    jQuery.ajax({
        url: pllb_ajax.ajax_url,
        type: "GET",
        data: {
            action: "pllb_koa_o_providers",
            nonce: pllb_ajax.nonce,
            service: "broadband"
        },
        success: function(response) {
            if (response.success && response.data && response.data.providers) {
                var $notSure = $hero.find(".koa-o-provider option[value='not-sure']");
                jQuery.each(response.data.providers, function(i, name) {
                    jQuery("<option>").val(name).text(name).insertBefore($notSure);
                });
            }
        }
        // Without the list they can still pick "Not sure" and carry on
    });
}

function koaOLookup($hero) {
    var $btn = $hero.find(".koa-o-find");
    var $steps = $hero.find(".koa-o-steps");
    var postcode = jQuery.trim($hero.find(".koa-o-postcode").val()).toUpperCase();
    if (!koaOPostcodeRegex.test(postcode)) {
        fireNotyf(koaOMessages.not_found, "error");
        return;
    }
    // A slower earlier lookup must not overwrite a newer one
    var run = ($hero.data("koaOLookup") || 0) + 1;
    $hero.data("koaOLookup", run);
    koaOFillAddresses($hero, []);
    koaOShowButtonSpinner($btn);
    $hero.find(".koa-o-status").text("Finding your address");
    jQuery.ajax({
        url: pllb_ajax.ajax_url,
        type: "POST",
        data: {
            action: "pllb_koa_o_addresses",
            nonce: pllb_ajax.nonce,
            postcode: postcode
        },
        success: function(response) {
            if (run !== $hero.data("koaOLookup")) {
                return;
            }
            var addresses = (response.success && response.data && response.data.addresses) || [];
            if (!addresses.length) {
                $steps.prop("hidden", true);
                $hero.find(".koa-o-status").text("");
                fireNotyf(koaOMessages.not_found, "error");
                return;
            }
            koaOFillAddresses($hero, addresses);
            // The postcode collapses into the address label, with a way back
            $hero.find(".koa-o-picked-postcode").text(addresses[0].postcode || postcode);
            $hero.find(".koa-o-postcode-row").prop("hidden", true);
            $steps.prop("hidden", false);
            $hero.find(".koa-o-status").text(addresses.length === 1 ? "Address found" : addresses.length + " addresses found");
            koaOLoadProviders($hero);
        },
        error: function(xhr) {
            if (run !== $hero.data("koaOLookup")) {
                return;
            }
            var code = xhr.responseJSON && xhr.responseJSON.data ? xhr.responseJSON.data.code : "";
            $steps.prop("hidden", true);
            $hero.find(".koa-o-status").text("");
            fireNotyf(koaOMessages[code === "not_found" || code === "busy" ? code : "error"], "error");
        },
        complete: function() {
            if (run === $hero.data("koaOLookup")) {
                koaOHideButtonSpinner($btn);
            }
        }
    });
}

// The embed script loads async, so a quick click waits for it briefly
function koaOWhenReady(onReady, onFail) {
    var tries = 0;
    var timer = setInterval(function() {
        if (window.KoaO && typeof window.KoaO.show === "function") {
            clearInterval(timer);
            onReady();
        } else if (++tries >= 100) {
            clearInterval(timer);
            onFail();
        }
    }, 100);
}

jQuery(document).on("click", ".hero-koa-o .koa-o-find", function() {
    koaOLookup(jQuery(this).closest(".hero-koa-o"));
});

jQuery(document).on("keypress", ".hero-koa-o .koa-o-postcode", function(e) {
    if (e.which === 13) {
        e.preventDefault();
        koaOLookup(jQuery(this).closest(".hero-koa-o"));
    }
});

jQuery(document).on("click", ".hero-koa-o .koa-o-change", function() {
    var $hero = jQuery(this).closest(".hero-koa-o");
    $hero.find(".koa-o-steps").prop("hidden", true);
    $hero.find(".koa-o-status").text("");
    koaOFillAddresses($hero, []);
    $hero.find(".koa-o-postcode-row").prop("hidden", false);
    $hero.find(".koa-o-postcode").val("").trigger("focus");
});

jQuery(document).on("change", ".hero-koa-o .koa-o-address, .hero-koa-o .koa-o-provider", function() {
    koaOUpdateCompare(jQuery(this).closest(".hero-koa-o"));
});

jQuery(document).on("click", ".hero-koa-o .koa-o-compare", function() {
    var $hero = jQuery(this).closest(".hero-koa-o");
    var $btn = jQuery(this);
    var $address = $hero.find(".koa-o-address option:selected");
    var provider = $hero.find(".koa-o-provider").val();
    if (!$address.val() || !provider) {
        return;
    }
    var options = {
        postcode: $address.attr("data-postcode") || jQuery.trim($hero.find(".koa-o-postcode").val()).toUpperCase(),
        uprn: $address.val(),
        // "Not sure" and "I'm not with anyone" send no provider
        currentProvider: provider === "not-sure" || provider === "none" ? undefined : provider,
        flow: "broadband",
        target: "koa-o",
        scroll: true
    };
    koaOShowButtonSpinner($btn);
    koaOWhenReady(function() {
        window.KoaO.show(options);
        koaOHideButtonSpinner($btn);
        koaOUpdateCompare($hero);
    }, function() {
        koaOHideButtonSpinner($btn);
        koaOUpdateCompare($hero);
        fireNotyf(koaOMessages.load, "error");
    });
    // GTM
    pushToGTM("lander_cta_click");
});

// Mobile: the widget is already loading, so the button just scrolls to it
jQuery(document).on("click", ".hero-koa-o .koa-o-scroll", function() {
    var $target = jQuery("#koa-o");
    if ($target.length) {
        jQuery("html, body").animate({
            scrollTop: $target.offset().top - 50
        }, 1000); // Duration of the scroll animation
    }
    // GTM
    pushToGTM("lander_cta_click");
});

// A postcode passed in the URL runs the lookup straight away
jQuery(function() {
    jQuery(".hero-koa-o[data-service='broadband']").each(function() {
        var $hero = jQuery(this);
        if (koaOPostcodeRegex.test(jQuery.trim($hero.find(".koa-o-postcode").val()))) {
            koaOLookup($hero);
        }
    });
});
